<div class="pdf-page app-aul-019-24" id="aul01924">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> COSMETIC DAMAGE TO ROOF SURFACE AND COVERING EXCLUSION</b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    We will not pay for cosmetic loss or damage to roof surfaces and coverings
    caused by the peril of wind and/or hail.
  </p>
  <p class="font-small">
    Cosmetic loss or damage means only that damage, including marring, pitting
    or other superficial damage that altered the physical appearance of the roof
    surfacing or roof covering, but does not result in damage that allows the
    penetration of water through the roof covering or does not result in the
    failure of the roof covering to perform its intended function to the same
    extent as it did before the cosmetic damage occurred.
  </p>
  <p class="font-small">
    For the purpose of this endorsement, roof surface and roof covering refers
    to the roofing material exposed to the elements, including shingles, tiles,
    cladding, metal or synthetic sheeting or similar materials covering the roof
    and includes all materials used in securing the roof surface and all
    materials applied to or under the roof surface for moisture protection, as
    well as roof flashing required in the replacement of a roof surface and roof
    covering.
  </p>
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
